export const removeCookie = async (name: string, path = '/', domain = '.socialcurator.com') => {
  const chosenDomain = process.env.NODE_ENV === 'development' ? 'localhost' : domain
  const expires = new Date(1971, 1, 1).toString()
  document.cookie = `${name}=;path=${path};domain=${chosenDomain};expires=${expires};SameSite=None;Secure;`
}
